import { IDevice } from "../types/deviceInterface";

export const isLteDevice = (device?: IDevice) =>
  Number(device?.fota_hardware_version) === 10 || Number(device?.fota_hardware_version) === 11;
